import { Directive, ElementRef, inject, Input } from '@angular/core';

// eslint-disable-next-line boundaries/element-types
import { injectWalkthroughRegister } from '@core/walkthrough-contracts';
import {
  RendererCallbackFn,
  WalkthroughStepId,
  WalkthroughStepOrigin,
  WalkthroughStepOriginConditional,
} from '@core/walkthrough-types';

@Directive({ selector: '[rtWalkthroughOriginStepId]', standalone: true })
export class WalkthroughStepOriginDirective implements WalkthroughStepOriginConditional {
  private readonly walkthroughStepsService = injectWalkthroughRegister();

  public elementRef = inject(ElementRef);

  @Input('rtWalkthroughOriginStepId') public rtWalkthroughOriginStepId:
    | WalkthroughStepId
    | undefined;

  @Input('rtWalkthroughOriginAfterDispose')
  public afterDisposeCallback: RendererCallbackFn;

  @Input('rtWalkthroughOriginBeforeRender')
  public beforeRenderCallback: RendererCallbackFn;

  @Input('rtWalkthroughOriginCleanup')
  public cleanupCallback: RendererCallbackFn;

  public ngOnInit(): void {
    if (this.rtWalkthroughOriginStepId) {
      this.walkthroughStepsService.register(
        this.rtWalkthroughOriginStepId,
        <WalkthroughStepOrigin>this,
      );
    }
  }

  public ngOnDestroy(): void {
    if (this.rtWalkthroughOriginStepId) {
      this.walkthroughStepsService.unregister(this.rtWalkthroughOriginStepId);
    }
  }
}
